<template>
    <div>
        <div class="search-box d-block mb-1" title="zoeken">
            <label class="d-none" for="searchinput">Zoekterm</label>
            <input
                id="searchinput"
                ref="searchInput"
                v-model="query"
                v-validate="'required'"
                aria-label="Zoekterm"
                label="Zoekterm"
                :placeholder="[[placholderText]]"
                class="search-button__input"
                type="search"
                autocomplete="off"
                @keydown.esc="hideSearchBox"
                @keydown.enter="setSearch"
            />

            <i class="fa fa-search" @click="setSearch()"></i>
        </div>
        <div
            v-if="
                query !== '' &&
                    !doneSearching &&
                    typeof suggestionResults !== 'undefined' &&
                    suggestionResults.length > 0
            "
            class="search-box-suggestions d-block mb-2"
        >
            <li v-for="(item, key) in suggestionResults" :key="key">
                <a href="#" @click.prevent="suggestionSelected(item.title)">
                    {{ item.title }}
                </a>
            </li>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import { EventBus } from '@/js/helpers/eventbus';

export default {
    data() {
        return {
            query: '',
            results: [],
            suggestionResults: [],
            images: [],
            url: '/api/searchapi/homesearch?q=',
            suggestionUrl: '/api/searchapi/homesearchSuggestions?q=',
            hideSearch: true,
            doneSearching: true,
            placholderText: 'Start jouw zoektocht'
        };
    },
    watch: {
        query: function() {
            this.doneSearching = false;
            if (this.query != '') {
                Axios.get(this.suggestionUrl + this.query)
                    .then(response => {
                        this.suggestionResults =
                            response.data.content.pagedResults;
                        this.query = this.query.replace('%20', ' ');
                        return true;
                    })
                    .catch(() => false);
            }
        }
    },
    mounted() {
        window.addEventListener('hashchange', this.hashChanged, false);
        EventBus.$on('no-search-result', this.resultPlaceholder);
        const searchTerm = this.getHashValue('q');
        if (searchTerm) {
            this.query = searchTerm.replace('%20', ' ');
            this.hashChanged();
        }
    },
    methods: {
        suggestionSelected(title) {
            this.query = title;
            this.executeSearch();
        },
        getSearchResults() {
            Axios.get(this.url + this.query)
                .then(response => {
                    this.results = response.data.content.pagedResults;
                    this.images = response.data.media.pagedResults;
                    EventBus.$emit('search-results', {
                        results: this.results,
                        images: this.images,
                        query: this.query
                    });

                    this.doneSearching = true;
                    return true;
                })
                .catch(() => false);
        },
        setSearch() {
            this.setHash('q', this.query);
            this.hashChanged();
        },
        executeSearch() {
            this.getSearchResults();

            if (this.results != null) {
                const checkExist = setInterval(function() {
                    const results = document.querySelector('#search-results');

                    if (results != null) {
                        results.scrollIntoView({
                            behavior: 'smooth'
                        });
                        clearInterval(checkExist);
                    }
                }, 100);
            }
        },
        resultPlaceholder(text) {
            this.query = '';
            this.placholderText = text;
        },
        hashChanged() {
            const searchTerm = this.getHashValue('q');
            if (searchTerm) {
                this.query = searchTerm;
            }
            this.executeSearch();
        },
        getHashValue(prop) {
            if (window.location.hash) {
                const hash = window.location.hash.substr(1);
                const result = hash.split('&').reduce(function(res, item) {
                    const parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                return result[prop];
            } else {
                return null;
            }
        },
        setHash(prop, val) {
            window.location.hash = prop + '=' + val;
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    padding: 0px;
    position: relative;
    overflow: hidden;
    border-radius: 50px;
    max-width: 100%;
    display: inline-block;
    width: 285px;
    background-color: $color-blue;

    @include media-breakpoint-up(md) {
        width: 490px;
        font-size: 1.4rem;
    }

    &:hover {
        transform: none;
    }

    i {
        color: $color-white;
        background-color: $color-blue;
        text-align: center;
        position: inherit;
        top: 0px;
        right: 0;
        line-height: 45px;
        width: 49px;
        height: 45px;
        font-size: 20px;
        cursor: pointer;

        @include media-breakpoint-up(md) {
            font-size: 25px;
            width: 67px;
            height: 47px;
            line-height: 55px;
        }
    }
}

.search-box-suggestions {
    padding: 10px 3px;
    position: relative;
    overflow: hidden;
    max-width: 100%;
    background-color: $color-white;

    li {
        margin-bottom: 4px;
        font-size: 0.925rem;
    }
}

.search-button__input {
    height: 45px;
    width: calc(100% - 50px);
    border: none;
    outline: none;
    color: $color-black;
    font-weight: $font-weight-light;
    float: left;
    transition: all 0.25s linear;
    background-color: white;
    padding-left: 25px;

    @include media-breakpoint-up(md) {
        height: 55px;
        width: calc(100% - 67px);
    }

    &::placeholder {
        color: $color-black;
        font-style: italic;
    }
}
</style>
